module.exports = __webpack_public_path__ + "img/Amphetamine (AMP).ab51106b.png";